var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3UserYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5948 11.7687C19.1972 11.7687 20.497 10.4698 20.497 8.8675C20.497 7.26516 19.1972 5.96625 17.5948 5.96625",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9291 14.9216C19.4076 14.9546 19.8833 15.0225 20.3517 15.1279C21.0026 15.2553 21.7854 15.522 22.0641 16.106C22.2419 16.48 22.2419 16.9154 22.0641 17.2903C21.7863 17.8742 21.0026 18.14 20.3517 18.2739",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28998 11.7687C4.68765 11.7687 3.38782 10.4698 3.38782 8.8675C3.38782 7.26516 4.68765 5.96625 6.28998 5.96625",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95577 14.9216C4.47727 14.9546 4.00152 15.0225 3.5331 15.1279C2.88227 15.2553 2.09943 15.522 1.82168 16.106C1.64293 16.48 1.64293 16.9154 1.82168 17.2903C2.09852 17.8742 2.88227 18.14 3.5331 18.2739",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9377 15.5464C15.1846 15.5464 17.9584 16.0377 17.9584 18.004C17.9584 19.9693 15.2029 20.479 11.9377 20.479C8.68997 20.479 5.91705 19.9876 5.91705 18.0214C5.91705 16.0551 8.67255 15.5464 11.9377 15.5464Z",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9377 12.7418C9.79638 12.7418 8.07947 11.0249 8.07947 8.8826C8.07947 6.74127 9.79638 5.02435 11.9377 5.02435C14.0791 5.02435 15.796 6.74127 15.796 8.8826C15.796 11.0249 14.0791 12.7418 11.9377 12.7418Z",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3UserYellow);
export default __webpack_public_path__ + "static/media/3-user-yellow.fd386b56a042e3e8752a3d78ccb8d86b.svg";
export { ForwardRef as ReactComponent };